import { render, staticRenderFns } from "./coze.vue?vue&type=template&id=62d55c07&scoped=true&"
import script from "./coze.vue?vue&type=script&lang=js&"
export * from "./coze.vue?vue&type=script&lang=js&"
import style0 from "./coze.vue?vue&type=style&index=0&id=62d55c07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d55c07",
  null
  
)

export default component.exports